import createTableStore from "ds/components/Table/store/useTableStore";

import {
  PROVIDER_VERSION_ARTIFACTS_TABLE_COLUMNS_CONFIG,
  PROVIDER_VERSION_ARTIFACTS_TABLE_STORAGE_KEY,
} from "./constants";

const useProviderVersionArtifactsTableStore = createTableStore({
  storageKey: PROVIDER_VERSION_ARTIFACTS_TABLE_STORAGE_KEY,
  config: PROVIDER_VERSION_ARTIFACTS_TABLE_COLUMNS_CONFIG,
});

export default useProviderVersionArtifactsTableStore;
